import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../users/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private authService: AuthService) { }
    public u: any
    User = {
        Role: 0
    }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.u = this.authService.getCurrentUser()
        // console.log("url"+route.url)
        // console.log("queryParams"+route)
        // console.log("firstChild"+route.pathFromRoot)
        if (localStorage.getItem('currentUser')) {
            // logged in so return true
            return true;
        }
        
        // if (this.u.Role == 1) {
        //     return true;
        // }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/_guards/auth.guard.ts